export const SHARED_STORAGE_CAP_BYTES: number = 10000000000;
export const PRIVATE_STORAGE_CAP_BYTES: number = 100000000000;
